<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div v-if="quizInfo.quizDetails.isGraded" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <p>{{ quizAchievedMarks + " / " +  newQuizTotal }}</p>
        <!-- <p>{{ quizAchievedMarks + " / " +  (quizInfo.quizTotal + (!quizInfo.quizTotal && quizTextTotal ? quizTextTotal : 0)) }}</p> -->
      </div>
    </div>
    <div v-if="quizInfo.finalStudentComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Student Comment:</label>
        <vs-textarea id="studentComment" readOnly v-model="quizInfo.finalStudentComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Comment:</label>
        <vs-textarea v-model="quizInfo.finalAssessorComment" />
      </div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Predefined Comments:</label>
        <v-select placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
      </div>
    </div>
    <div v-if="quizInfo.finalModeratorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>Moderator Final Comment:</strong></label>
        <vs-textarea v-model="quizInfo.finalModeratorComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizAchievedMarks: {
        type: Number,
        required: false
      },
      quizTextTotal: {
        type: Number,
        required: false
      },
      quizInfo: {
        type: Object,
        required: false
      },
      assessorComments: {
        type: String,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      },
      newQuizTotal: {
        type: Number,
        required: false
      },
    },
    data() {
      return {
        predCommentDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    methods: {
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.quizInfo.finalAssessorComment == null){
            self.quizInfo.finalAssessorComment = "";
          }
          self.quizInfo.finalAssessorComment += self.predCommentDropdown.label + " ";
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">
  #studentComment {
    box-shadow: 0 4px 20px 0 rgba(var(--vs-danger),0.3);
  }
</style>
